import { createContext } from "react";
const ProjectContext = createContext(null);
const UserContext = createContext(null);
const ActivityContext = createContext(null);
const ProductContext = createContext(null);
const LineContext = createContext(null);
const DiffusionProductContext = createContext(null);
const DescriptionContext = createContext(null)
export {
  ProjectContext,
  UserContext,
  ActivityContext,
  ProductContext,
  LineContext,
  DiffusionProductContext,
  DescriptionContext
};
